import { render, staticRenderFns } from "./DecoContestPoster.vue?vue&type=template&id=caa153fe&"
import script from "./DecoContestPoster.vue?vue&type=script&lang=ts&"
export * from "./DecoContestPoster.vue?vue&type=script&lang=ts&"
import style0 from "./DecoContestPoster.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports